import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgComponent = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="200"
    height="98"
    viewBox="0 0 200 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    <path d="M191.055 42.8071C189.477 39.4698 186.111 37.312 182.483 37.312C178.854 37.312 175.475 39.4698 173.911 42.8071L165.694 60.2174H171.873L174.647 54.3336H190.331L193.105 60.2174H199.284L191.055 42.8071ZM187.65 48.6642H177.328L178.933 45.2733C179.59 43.8927 180.984 42.9948 182.495 42.9948C184.008 42.9948 185.401 43.8927 186.058 45.2733L187.65 48.6642Z" />
    <path d="M160.173 49.026C162.763 48.3559 164.565 45.9836 164.565 43.2628C164.565 39.9791 161.948 37.312 158.727 37.312H135.181V42.7401H159.003V43.6515L138.77 48.5034C136.18 49.1735 134.379 51.5458 134.379 54.2666C134.379 57.5503 136.996 60.2174 140.216 60.2174H163.762V54.7893H139.94V53.851L160.173 49.026Z" />
    <path d="M100.377 43.4907V54.0388C100.377 57.4431 103.099 60.2174 106.438 60.2174H130.576V54.7893H105.951V51.4787H130.576V46.0507H105.951V42.7401H130.576V37.312H106.438C103.099 37.312 100.377 40.0864 100.377 43.4907Z" />
    <path d="M58.8574 37.312H40.7805C37.4411 37.312 34.7197 40.0864 34.7197 43.4907V54.0388C34.7197 57.4431 37.4411 60.2174 40.7805 60.2174H58.8574C62.1967 60.2174 64.9181 57.4431 64.9181 54.0388V43.4907C64.9181 40.0864 62.1967 37.312 58.8574 37.312ZM59.357 42.9948V54.5481H40.294V42.9948H59.357Z" />
    <path d="M24.5875 46.3455H5.52448V37.312H-0.0498047V60.2174H5.52448V52.0149H24.5875V60.2174H30.1486V37.312H24.5875V46.3455Z" />
    <path d="M67.5532 42.9948H79.8718V60.2174H85.433V42.9948H97.7516V37.312H67.5532V42.9948Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
